import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    warehouses: [],
    warehouseScroll: [],
    warehouseScrollMeta: {
        current_page: 1,
        last_page: 1,
        currentQuery: ''
    },
    warehouseScrollCount : 0,
    usersDoesNotHaveWarehouse: [],
    storeProducts: []
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
